import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import styled from 'styled-components';
import { PAGINATION_ALIGNMENT, PAGINATION_LABEL_POSITION, PAGINATION_GAP, PAGINATION_FIXED_BUTTON_STYLING, PAGINATION_LABEL_TYPOGRAPHY } from './Pagination.constants.js';

var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var StyledPagination = styled.nav(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  width: fit-content;\n  ", "\n  gap: ", ";\n  flex-direction: ", "\n  flex-wrap: wrap;\n  justify-content: ", "\n"])), function (_ref) {
  var $alignment = _ref.$alignment;
  return $alignment === PAGINATION_ALIGNMENT.RIGHT && 'margin-left: auto;';
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.sizing.small;
}, function (_ref3) {
  var $labelPosition = _ref3.$labelPosition;
  return $labelPosition === PAGINATION_LABEL_POSITION.LEFT ? 'row-reverse;' : 'row;';
}, function (_ref4) {
  var $alignment = _ref4.$alignment,
    $labelPosition = _ref4.$labelPosition;
  return ($alignment === PAGINATION_ALIGNMENT.RIGHT || $labelPosition === PAGINATION_LABEL_POSITION.RIGHT) && !($alignment === PAGINATION_ALIGNMENT.RIGHT && $labelPosition === PAGINATION_LABEL_POSITION.RIGHT) ? 'flex-start;' : 'flex-end;';
});
var List = styled.ol(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  gap: ", ";\n"])), function (_ref5) {
  var $size = _ref5.$size;
  return PAGINATION_GAP[$size];
});
var ButtonGroupContainer = styled.li(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", "\n\n  button {\n    font-variant-numeric: tabular-nums;\n    ", "\n  }\n"])), function (_ref6) {
  var $hasFixedWidth = _ref6.$hasFixedWidth,
    $buttonGroupWidth = _ref6.$buttonGroupWidth;
  return $hasFixedWidth && "\n      > div {\n        min-width: ".concat($buttonGroupWidth, "px;\n        max-width: ").concat($buttonGroupWidth, "px;\n      }\n    ");
}, function (_ref7) {
  var $size = _ref7.$size,
    $hasFixedWidth = _ref7.$hasFixedWidth;
  return $hasFixedWidth ? "\n          padding-right: 0;\n          padding-left: 0;\n          flex: 1;\n        " : PAGINATION_FIXED_BUTTON_STYLING[$size];
});
var PaginationLabel = styled.span(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  white-space: nowrap;\n  color: ", ";\n  ", "\n  order: 2;\n"])), function (_ref8) {
  var theme = _ref8.theme;
  return theme.colours.ink.primary.main;
}, function (_ref9) {
  var $size = _ref9.$size;
  return PAGINATION_LABEL_TYPOGRAPHY[$size];
});

export { ButtonGroupContainer, List, PaginationLabel, StyledPagination };
//# sourceMappingURL=Pagination.styles.js.map
